/* eslint-disable @atlaskit/ui-styling-standard/no-dynamic-styles */

import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import type { FrameStyle } from '../types';

export const className = 'media-card-frame';
export const embedHeaderHeight = 32;

export interface WrapperProps {
	className?: string;
	frameStyle?: FrameStyle;
	inheritDimensions?: boolean;
	isInteractive?: boolean;
	isSelected?: boolean;
	maxWidth?: number;
	minWidth?: number;
}

export interface HeaderProps {
	frameStyle?: FrameStyle;
}

export interface ContentProps {
	/**
	 * Whether to show a scroll bar (use overflow: auto) or hide overflow (overflow:hidden).
	 * Always set to true for unresolved embeds, otherwise the connect account button may be hidden and unreachable.
	 */
	allowScrollBar: boolean;
	frameStyle?: FrameStyle;
	isInteractive: boolean;
	/**
	 * Remove the overflow: ... CSS property altogether.
	 */
	removeOverflow?: boolean;
}

export interface ImageProps {
	size: number;
}

export interface ThumbnailProps {
	src: string;
}

export interface PlaceholderProps {
	isPlaceholder: boolean;
}

const getSizeWithUnit = (value: string | number = '100%') => {
	const unit = typeof value === 'number' ? 'px' : '';
	return `${value}${unit}`;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled,@atlaskit/ui-styling-standard/no-exported-styles
export const Image = styled.img({
	borderRadius: token('radius.small', '3px'),
	overflow: 'hidden',
	width: (props: ImageProps) => getSizeWithUnit(props.size),
	height: (props: ImageProps) => getSizeWithUnit(props.size),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled,@atlaskit/ui-styling-standard/no-exported-styles
export const Thumbnail = styled.div({
	borderRadius: token('radius.small', '3px'),
	width: '48px',
	height: '48px',
	float: 'right',
	marginTop: token('space.050'),
	marginRight: 0,
	marginBottom: token('space.150'),
	marginLeft: token('space.150'),
	backgroundColor: token('color.skeleton'),
	backgroundSize: 'cover',
	backgroundImage: (props: ThumbnailProps) => `url(${props.src})`,
});
